module.exports = __webpack_public_path__ + "static/media/swift.32a50406.png";